import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledCircularArrows: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_circular-arrows"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="circular-arrows icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 21 20"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M16.2485 6.01C16.4278 6.01 16.5924 6.07292 16.7215 6.17788C17.8094 7.09184 18.5009 8.46516 18.5009 10C18.5009 12.6888 16.3786 14.8818 13.7178 14.9954L13.5009 15H9.05909L10.2788 16.2197C10.5451 16.4859 10.5693 16.9026 10.3515 17.1962L10.2788 17.2803C10.0126 17.5466 9.59591 17.5708 9.3023 17.3529L9.21818 17.2803L6.71818 14.7803C6.45192 14.5141 6.42771 14.0974 6.64556 13.8038L6.71818 13.7197L9.21818 11.2197C9.51108 10.9268 9.98595 10.9268 10.2788 11.2197C10.5451 11.4859 10.5693 11.9026 10.3515 12.1962L10.2788 12.2803L9.05909 13.5H13.5009C15.3695 13.5 16.8961 12.0357 16.9958 10.192L17.0009 10C17.0009 8.91885 16.5107 7.95219 15.7404 7.31017C15.592 7.17538 15.4985 6.97861 15.4985 6.76C15.4985 6.34579 15.8343 6.01 16.2485 6.01ZM10.7182 2.71967C10.9845 2.4534 11.4011 2.4292 11.6947 2.64705L11.7788 2.71967L14.2788 5.21967L14.3515 5.30379C14.5451 5.56478 14.5475 5.92299 14.3586 6.18638L14.2788 6.28033L11.7788 8.78033L11.6947 8.85295C11.4337 9.0466 11.0755 9.04899 10.8121 8.86012L10.7182 8.78033L10.6456 8.69621C10.4519 8.43522 10.4495 8.07701 10.6384 7.81362L10.7182 7.71967L11.9371 6.5H7.49609C5.62753 6.5 4.10097 7.96428 4.00127 9.80796L3.99609 10C3.99609 11.0831 4.4881 12.0514 5.26082 12.6934C5.40702 12.8289 5.49851 13.0238 5.49851 13.24C5.49851 13.6542 5.16273 13.99 4.74851 13.99C4.55723 13.99 4.38267 13.9184 4.25018 13.8005C3.17717 12.8872 2.49609 11.5232 2.49609 10C2.49609 7.31124 4.6184 5.11818 7.2792 5.00462L7.49609 5H11.9371L10.7182 3.78033L10.6456 3.69621C10.4277 3.4026 10.4519 2.98594 10.7182 2.71967Z" />
      </svg>
    </span>
  );
};

export { FilledCircularArrows };
